import API from 'api'
import * as actionTypes from './actionTypes'

export const fetch = () => {
  return dispatch => {

    API.notices.fetch(
      response => dispatch( noticeFetched(response) ),
      error => {}
    )

  }
}

const noticeFetched = ({ content }) => ({ type: actionTypes.NOTICE_FETCHED, content })



// WEBPACK FOOTER //
// ./src/store/notices/actions.js